//============================
//# mlsysisync_invhead DTO
//# Számlafej köztes tábla — kiegészítve a felületi állapot-mezőkkel és számolt mezőkkel
//============================
import IfaceSyncInvoiceHead, { IfaceSyncInvoiceHeadDefaultProps } from "./IfaceSyncInvoiceHead";

export default interface IfaceSyncInvoiceHeadDTO extends IfaceSyncInvoiceHead {
    /** Kiválasztva (tömeges műveletekhez) */
    selected: boolean;
    /** Szerkesztés alatt */
    inEdit: boolean;
    /** Sor lenyitható részletek master toggle */
    showDetails: boolean;
    /** Szinkron előzmények megjelenítése (showDetails-szel együtt) */
    showHistory: boolean;
    /** Számlatételek lenyitva (showDetails-szel együtt, showHistory-val kölcsönösen kizáró) */
    showItems: boolean;
    /** Betöltött előzmény rekordok */
    history: IfaceSyncInvoiceHeadDTO[] | null;
    /** Utolsó szinkronizálás pontos ideje (UpdDate + UpdTime kombinálva) */
    updDateTime: Date;
    /** Utoljára módosító munkatárs neve */
    updUserName: string;
    /** Szinkron státusz megnevezése */
    syncStatusName: string;
    /** A külső partner kódhoz tartozó partner név a partner köztes táblából */
    partnerName: string;
    /** A külső partner kódhoz tartozó K2D partner azonosító a partner köztes táblából */
    partnerId: number;
    /** A másodlagos külső partner kódhoz tartozó partner név */
    partner2Name: string;
    /** A másodlagos külső partner kódhoz tartozó K2D partner azonosító */
    partner2Id: number;
    /** A külső fizetési mód kódhoz tartozó K2D fizetési mód megnevezés (a szinkron szótárból mappelve) */
    payModeName: string;
    /**
     * A számlatételekből összegzett bruttó a számla pénznemében. A fej bruttója az interfészről jön,
     * ez pedig a tételek összege — eltérés esetén a felület figyelmeztet rá.
     */
    itemsCurrTotal: number | null;
    /**
     * A szinkron sor be van emelve: a belső azonosítójához tartozik bejövő számla, ami nem hibás
     * rögzítés státuszú. Ilyenkor a rekord lezárt, semmi nem módosítható rajta.
     */
    isImported: boolean;
    /**
     * A szinkron sorhoz hibás rögzítés státuszú bejövő számla tartozik. Ez nem zárja le a rekordot
     * (újra lehet szinkronizálni), csak tájékoztatunk róla.
     */
    hasWrongItemInvoice: boolean;
}

/** Partner megjelenítés a számla felületeken: "(partner kód) partner név" — név nélkül csak a kód */
export function partnerCodeAndName(invoice: IfaceSyncInvoiceHeadDTO): string {
    if (!invoice.partnerCode) return "";
    return invoice.partnerName ? `(${invoice.partnerCode}) ${invoice.partnerName}` : invoice.partnerCode;
}

/** Fizetési mód megjelenítés: "(külső kód) K2D megnevezés" — mappelés nélkül csak a kód */
export function payModeCodeAndName(invoice: IfaceSyncInvoiceHeadDTO): string {
    if (!invoice.payMode) return "";
    return invoice.payModeName ? `(${invoice.payMode}) ${invoice.payModeName}` : invoice.payMode;
}

export const IfaceSyncInvoiceHeadDTODefaultProps: IfaceSyncInvoiceHeadDTO = {
    ...IfaceSyncInvoiceHeadDefaultProps,
    selected: false,
    inEdit: false,
    showDetails: false,
    showHistory: false,
    showItems: false,
    history: null,
    updDateTime: new Date(),
    updUserName: "",
    syncStatusName: "",
    partnerName: "",
    partnerId: 1,
    partner2Name: "",
    partner2Id: 1,
    payModeName: "",
    itemsCurrTotal: null,
    isImported: false,
    hasWrongItemInvoice: false,
}
